import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Divider, message, Popconfirm, Popover, Radio, Spin, Table, Tag } from 'antd';

import moment from 'moment';
import util from '@util/index';
import {
  queryPayableDetailStatistics,
  queryPayablePaid,
  queryPayablePaidDeposit,
  queryPayablePaidLiquidate,
  queryPayablePaidTodo,
  queryPayablePaidTurn,
  queryPayableRefund,
  querySavePayableSleep,
} from '@api/incubator/payable';
import { getPayableStatistics } from '@store/modules/incubator/payable_statis';
import ModalDormant from './ModalDormant';

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class TablePaid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statis: {},
      dataSource: {
        list: [],
        pagination: {},
      },
      dorVisible: false,
      dorLoading: false,
    };
  }

  componentDidMount() {
    const { billTab, condition } = this.props;
    this.type = billTab.paidType || '-1';
    this.current = billTab.paidPage || 1;
    this.pageSize = billTab.paidPageSize || 10;
    this.condition = condition;
    this.getData();
    this.getPayableDetailStatistics();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(key => {
        return nextProps.condition[key] !== this.condition[key];
      })
    ) {
      this.condition = nextProps.condition;
      this.getData();
      this.getPayableDetailStatistics();
    }
  }

  onChange = e => {
    this.type = e.target.value;
    this.current = 1;
    this.getData();
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getData();
  };

  confirm = uuid => {
    const { condition } = this.props;
    queryPayableRefund({
      uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getData();
        this.getPayableDetailStatistics();
        this.props.dispatch(getPayableStatistics({ ...condition }));
      } else {
        message.error(res.message);
      }
    });
  };

  showDormant = uuid => {
    this.sleepUuid = uuid;
    this.setState({ dorVisible: true });
  };

  handleDorOk = value => {
    this.setState({ dorLoading: true });
    querySavePayableSleep({
      payableUuid: this.sleepUuid,
      remark: value.refuse,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.setState({ dorVisible: false });
        this.getData();
      } else {
        message.error(res.message);
      }
      this.setState({ dorLoading: false });
    });
  };

  handleDorCancel = () => {
    this.setState({ dorVisible: false });
  };

  setData = res => {
    const { pageSize } = this;
    this.props.onPageChange(this.type, this.current, pageSize);
    this.setState({
      isLoading: false,
      dataSource: {
        list: res.data,
        pagination: {
          pageSize,
          total: res.totalSize,
          current: this.current,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: [10, 20, 50, 100],
        },
      },
    });
  };

  getPayablePaid = () => {
    const { pageSize } = this;
    queryPayablePaid({
      ...this.condition,
      type: this.type >= 0 ? this.type : '',
      limit: pageSize,
      start: this.current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setData(res);
      }
    });
  };

  getPayablePaidDeposit = () => {
    const { pageSize } = this;
    queryPayablePaidDeposit({
      ...this.condition,
      limit: pageSize,
      start: this.current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setData(res);
      }
    });
  };

  getPayablePaidLiquidate = () => {
    const { pageSize } = this;
    queryPayablePaidLiquidate({
      ...this.condition,
      limit: pageSize,
      start: this.current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setData(res);
      }
    });
  };

  getPayablePaidTurn = () => {
    const { pageSize } = this;
    queryPayablePaidTurn({
      ...this.condition,
      limit: pageSize,
      start: this.current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setData(res);
      }
    });
  };

  getPayablePaidTodo = () => {
    const { pageSize } = this;
    queryPayablePaidTodo({
      ...this.condition,
      limit: pageSize,
      start: this.current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setData(res);
      }
    });
  };

  getData = () => {
    this.setState({
      isLoading: true,
    });
    switch (this.type) {
      case '-1':
      case '1':
      case '2':
      case '3':
        this.getPayablePaid();
        break;
      case '4':
        this.getPayablePaidDeposit();
        break;
      case '5':
        this.getPayablePaidLiquidate();
        break;
      case '6':
        this.getPayablePaidTurn();
        break;
      case '7':
        this.getPayablePaidTodo();
        break;
      default:
        this.getPayablePaid();
        break;
    }
  };

  getPayableDetailStatistics = () => {
    this.setState({
      isStatisLoading: true,
    });
    queryPayableDetailStatistics({
      tab: 'PAID',
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          statis: res.data,
          isStatisLoading: false,
        });
      }
    });
  };

  getOtherColumns = () => {
    let other = [];

    const renderMoney = (key, title) => {
      return {
        title,
        dataIndex: key,
        width: 200,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      };
    };

    const renderDate = (key, title) => {
      return {
        title,
        dataIndex: key,
        width: 200,
        render: (text, record) => {
          const day = Math.floor((Date.now() - text) / 86400000);
          return (
            <div>
              {text ? (
                <span>
                  {moment.unix(text / 1000).format('YYYY-MM-DD')}({day > 0 ? '逾期' : '剩余'}
                  {Math.ceil(Math.abs(day))}
                  天)
                </span>
              ) : null}
            </div>
          );
        },
      };
    };

    switch (this.type) {
      case '-1':
      case '1':
      case '2':
      case '3':
        other = [
          renderMoney('price', '待收款'),
          {
            ...renderMoney('confirm', '已收款'),
            render: (value, record) => {
              return (
                <span>
                  {value ? util.numberFormat(value) : 0}
                  {record.turn && <span style={{ color: 'red' }}>(转结金额:{record.turn})</span>}
                </span>
              );
            },
          },
          {
            title: '款项状态',
            dataIndex: 'payStatus',
            width: 200,
            render: (text, record) => {
              let statusFont = '';
              if (record.price > 0) {
                if (record.confirm > 0) {
                  statusFont = '部分匹配';
                } else {
                  statusFont = '没有匹配';
                }
              } else {
                statusFont = '完成匹配';
              }
              return <span>{statusFont}</span>;
            },
          },
          {
            title: '实收日期',
            dataIndex: 'date',
            width: 200,
            render: (text, record) =>
              text ? (
                <span>
                  {moment.unix(text / 1000).format('YYYY-MM-DD')}(
                  {record.interval > 0 ? '提前' : '逾期'}
                  {Math.ceil(Math.abs(record.interval) / 1440)}
                  天)
                </span>
              ) : null,
          },
        ];
        break;
      case '4':
        other = [renderMoney('deposit', '签约中已收押金金额'), renderDate('date', '合同到期日期')];
        break;
      case '5':
        other = [renderMoney('liquidate', '押金转违约金金额')];
        break;
      case '6':
        other = [renderMoney('turn', '已到期押金已转结金额')];
        break;
      case '7':
        other = [
          renderMoney('price', '已到期押金待处理金额'),
          renderDate('date', '合同到期日期'),
          {
            title: '操作',
            dataIndex: 'done',
            width: 100,
            render: (text, record) => (
              <div>
                <Popconfirm title="确定做退款操作吗？" onConfirm={() => this.confirm(record.uuid)}>
                  <a>退款</a>
                </Popconfirm>
                {record.sleepStatus === 1 ? '' : <Divider type="vertical" />}
                {record.sleepStatus === 1 ? (
                  ''
                ) : (
                  <a onClick={() => this.showDormant(record.uuid)}>休眠</a>
                )}
              </div>
            ),
          },
        ];
        break;
      default:
        other = [];
        break;
    }
    return other;
  };

  columns = () => {
    const { type } = this.props;
    const baseColumns = [
      {
        title: '账单编号',
        dataIndex: 'no',
        width: 200,
        render: (text, record) => {
          const content = (
            <div>
              <p>时间:{moment(record.sleepDate).format('YYYY-MM-DD')}</p>
              <p>操作人员:{record.sleepUser}</p>
              <p>原因:{record.sleepRemark}</p>
            </div>
          );
          return (
            <div>
              {record.sleepStatus === 1 ? (
                <Popover content={content}>
                  <Tag color="gray">休眠</Tag>
                </Popover>
              ) : (
                ''
              )}

              <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>
            </div>
          );
        },
      },
      {
        title: '公司名称',
        dataIndex: 'custom',
        width: 200,
      },
      {
        title: '缴费周期',
        dataIndex: 'beginDate',
        width: 200,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        width: 200,
        render: (text, record) => <span>{type[text]}</span>,
      },
    ];
    const other = this.getOtherColumns();
    return [...baseColumns, ...other];
  };

  render() {
    const {
      dataSource: { list, pagination },
      statis: { all, sign, turn, other, settled, liquidate, oregistapp, pendingDeposit },
      isLoading,
      dorVisible,
      dorLoading,
      isStatisLoading,
    } = this.state;
    const { billTab } = this.props;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <RadioGroup onChange={this.onChange} defaultValue={billTab.paidType || '-1'}>
            <div style={{ marginBottom: '8px' }}>
              <RadioButton value="-1">
                全部
                <span>{isStatisLoading ? <Spin size="small" /> : util.numberFormat(all || 0)}</span>
              </RadioButton>
              <RadioButton value="1">
                工位收入
                <span>
                  {isStatisLoading ? <Spin size="small" /> : util.numberFormat(settled || 0)}
                </span>
              </RadioButton>
              <RadioButton value="2">
                地址收入
                <span>
                  {isStatisLoading ? <Spin size="small" /> : util.numberFormat(oregistapp || 0)}
                </span>
              </RadioButton>
              <RadioButton value="3">
                其他收入
                <span>
                  {isStatisLoading ? <Spin size="small" /> : util.numberFormat(other || 0)}
                </span>
              </RadioButton>
            </div>
            <div>
              <RadioButton value="4">
                签约中押金
                <span>
                  {isStatisLoading ? <Spin size="small" /> : util.numberFormat(sign || 0)}
                </span>
              </RadioButton>
              <RadioButton value="5">
                押金转违约金
                <span>
                  {isStatisLoading ? <Spin size="small" /> : util.numberFormat(liquidate || 0)}
                </span>
              </RadioButton>
              <RadioButton value="6">
                已到期押金（已结转）
                <span>
                  {isStatisLoading ? <Spin size="small" /> : util.numberFormat(turn || 0)}
                </span>
              </RadioButton>
              <RadioButton value="7">
                已到期押金（待处理）
                <span>
                  {isStatisLoading ? <Spin size="small" /> : util.numberFormat(pendingDeposit || 0)}
                </span>
              </RadioButton>
            </div>
          </RadioGroup>
        </div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.onTableChange}
          rowKey="uuid"
          loading={isLoading}
          scroll={{ x: true, y: false, scrollToFirstRowOnChange: true }}
        />
        <ModalDormant
          visible={dorVisible}
          loading={dorLoading}
          handleOk={this.handleDorOk}
          handleCancel={this.handleDorCancel}
        />
      </div>
    );
  }
}

export default connect(state => ({
  statisticsData: state.payable_statis,
}))(TablePaid);



// WEBPACK FOOTER //
// ./src/components/incubator/bill/TablePaid.js